import React, { useEffect, useState, useContext } from 'react';
import * as XLSX from 'xlsx';
import Notify from '@shared/notify';
import Modal from 'react-bootstrap/Modal';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import moment from 'moment';
import Button from 'react-bootstrap/Button';
import { AuthContext } from '@shared/context/AuthContext';
import APIService from '@shared/services/api';

const BulkUploadTransportAppUser = (props: any) => {
    const { setLoader, setProgress, setProgressType, setDemandStatus }: any = useContext(AuthContext);
    const [recordCount, setRecordCount] = useState(null);
    const [uploadTrue, setUploadTrue] = useState(false);
    const [pincodes, setpincodes] = useState([]);
    const [showHideUploadBtn, setshowHideUploadBtn] = useState(false);
    const [list, setList] = useState([]);
    const [upfile, setupFile] = useState('');
    const [loaderstate, setLoaderState] = useState(false);
    const [location, setLocation] = useState([]);

    useEffect(() => {
        try {
            const cities = (props?.locationData || []).map(i => i.city.toLowerCase());
            const pincode = (props?.locationData || []).map(i => i.pincode.toString());
            setLocation(cities);
            setpincodes(pincode);
        } catch (error) { }
    }, [props?.locationData]);

    const handlefile = (e: any) => {
        try {
            setLoaderState(true);

            const files = e.target.files;
            if (files && files.length > 0) {
                const file = files[0];
                if (
                    checkFileExtension(file.name, 'csv') ||
                    checkFileExtension(file.name, 'xlsx') ||
                    checkFileExtension(file.name, 'xls')
                ) {
                    fileReader(e);
                } else {
                    Notify('error', 'Invalid file. Accept only xlsx, xls, CSV');
                }
            }
        } catch (error) { }
    };

    const checkFileExtension = (filename, extension) => {
        const regex = new RegExp('\\.' + extension + '$', 'i');
        return regex.test(filename);
    };

    const fileReader = (eFile: any) => {
        try {
            const file = eFile.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = async (e: any) => {
                    const data = e.target.result;
                    const workbook = XLSX.read(data, {
                        type: 'binary',
                        // cellDates: true
                    });
                    const sheetName = workbook.SheetNames[0]; // Assuming the data is in the first sheet
                    const worksheet = workbook.Sheets[sheetName];
                    // Assuming the data starts from A2 (skip the header)
                    const records: any = XLSX.utils.sheet_to_json(worksheet, { raw: false }); //{ header: 1, range: 1 }
                    const rLength = records.length;
                    const maxSize = 4 * 1024 * 1024; // 4MB in bytes

                    if (rLength === 0) {
                        setLoader(false);
                        return Notify('error', 'No records found in sheet');
                    } else if (rLength > 2000) {
                        setLoader(false);
                        return Notify('error', 'Allow only 1000 records at once');
                    } else if (file.size > maxSize) {
                        setLoader(false);
                        return Notify('error', 'Allow only max 4MB file');
                    } else {
                        const res: any = await dataValidation(records);
                        setLoaderState(false);
                        setUploadTrue(true);
                        setList(res.records || []);
                        setshowHideUploadBtn(res?.isValid || false);
                        if (res?.isValid && res.records?.length > 0) {
                            setupFile(file);
                        }
                    }
                };
                reader.readAsBinaryString(file);
            }
        } catch (error) { }
    };

    const dataValidation = (records: any) => {
        return new Promise((resolve, reject) => {
            try {
                if (records?.length > 0) {
                    dataValidationFn(records, 0, true, null, null, res => {
                        resolve(res);
                    });
                } else {
                    resolve(records);
                }
            } catch (error) { }
        });
    };

    const dataValidationFn = (records, i, isValid, phoneNo, email, fn) => {
        try {
            if (records?.[i]) {
                const rec: any = records?.[i];
                records[i]['errors'] = {};

                console.log('rec', rec);

                if (!rec.fullName) {
                    isValid = false;
                    records[i]['errors']['fullName'] = 'Full Name cannot be empty';
                }

                if (!rec.companyName) {
                    isValid = false;
                    records[i]['errors']['companyName'] = 'Company Name cannot be empty';
                }
                if (!rec.phone || parseFloat(rec?.phone) == 0) {
                    isValid = false;
                    records[i]['errors']['phone'] = 'Phone cannot be empty or zero';
                } else if (rec?.phone && !/^[6789]\d{9}$/.test(rec?.phone)) {
                    isValid = false;
                    records[i]['errors']['phone'] = 'Invlaid Phone No';
                } else if (phoneNo == rec.phone) {
                    isValid = false;
                    records[i]['errors']['phone'] = 'This phone no. is already present in sheet more then once';
                } else {
                    phoneNo = rec.phone;
                }

                if (!rec.email) {
                    isValid = false;
                    records[i]['errors']['email'] = 'Email cannot be empty';
                } else if (rec?.email && !/^\S+@\S+\.\S+$/.test(rec?.email)) {
                    isValid = false;
                    records[i]['errors']['email'] = 'Invlaid Email id';
                }
                // else if (email == rec.email) {
                //     isValid = false;
                //     records[i]['errors']['email'] = 'This email is already present in sheet more then once';
                // } else {
                //     email = rec.email;
                // }

                if (!rec.pincode || parseFloat(rec?.pincode) == 0) {
                    isValid = false;
                    records[i]['errors']['pincode'] = 'Pincode cannot be empty or zero';
                } else if (rec?.pincode && !pincodes.toString().includes(rec?.pincode)) {
                    isValid = false;
                    records[i]['errors']['pincode'] = 'Pincode does not exists';
                }

                if (!rec.state) {
                    isValid = false;
                    records[i]['errors']['state'] = 'State name cannot be empty';
                }

                if (!rec.city) {
                    isValid = false;
                    records[i]['errors']['city'] = 'City Name cannot be empty';
                }

                if (!rec.address) {
                    isValid = false;
                    records[i]['errors']['address'] = 'Address cannot be empty';
                }

                if (!rec.GST || parseFloat(rec?.GST) == 0) {
                    isValid = false;
                    records[i]['errors']['GST'] = 'GST cannot be empty or zero';
                } else if (rec?.email && !/^[0-9A-Za-z]{15}$/.test(rec?.GST)) {
                    isValid = false;
                    records[i]['errors']['GST'] = 'Invlaid GST No';
                }

                if (!rec.PAN || parseFloat(rec?.PAN) == 0) {
                    isValid = false;
                    records[i]['errors']['PAN'] = 'PAN cannot be empty or zero';
                } else if (rec?.PAN && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(rec?.PAN)) {
                    isValid = false;
                    records[i]['errors']['PAN'] = 'Invlaid PAN No';
                }

                if (!rec.aadharNo || parseFloat(rec?.aadharNo) == 0) {
                    isValid = false;
                    records[i]['errors']['aadharNo'] = 'Aadhar no cannot be empty or zero';
                } else if (rec?.aadharNo && !/^[0-9]{12}$/.test(rec?.aadharNo)) {
                    isValid = false;
                    records[i]['errors']['aadharNo'] = 'Invlaid Aadhar No';
                }

                i++;
                dataValidationFn(records, i, isValid, phoneNo, email, fn);
            } else {
                fn({ records, isValid: isValid });
            }
        } catch (error) {
            fn({ records, isValid: isValid });
        }
    };

    const handelModel = (flag: boolean) => {
        try {
            props.setShowHideModel(flag);
        } catch (error) { }
    };

    const itemdata = (item: any, index, value, isDate = false) => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    {item?.errors && Object.keys(item.errors).length > 0 && item?.errors?.[value] ? (
                        <>
                            <span style={{ color: '#BB0A1E' }}>{item[value]}</span>
                        </>
                    ) : (
                        <>
                            <span>{item[value]}</span>
                        </>
                    )}
                    {item?.errors && Object.keys(item.errors).length > 0 && item?.errors?.[value] && (
                        <>
                            <span
                                className="material-symbols-outlined"
                                aria-hidden="true"
                                data-tooltip-id={`my-tooltip-${index}-${value}`}
                                style={{ color: '#BB0A1E', fontSize: '16px', marginLeft: '3px' }}
                            >
                                info
                            </span>
                            <ReactTooltip
                                id={`my-tooltip-${index}-${value}`}
                                place="bottom"
                                content={item?.errors?.[value]}
                                style={{ backgroundColor: '#BB0A1E', color: 'white', marginLeft: '5px' }}
                            />
                        </>
                    )}
                </div>
            </>
        );
    };

    const listLog = list?.map((item: any, index) => {
        return (
            <>
                <tr
                    key={index}
                    style={
                        item?.errors && Object.keys(item.errors).length > 0
                            ? { backgroundColor: '#FCF3F4' }
                            : { backgroundColor: 'rgba(0, 131, 62, 0.3)' }
                    }
                >
                    <td>{index + 2}</td>
                    <td>{itemdata(item, index, 'fullName')}</td>
                    <td>{itemdata(item, index, 'companyName')}</td>
                    <td>{itemdata(item, index, 'phone', true)}</td>
                    <td>{itemdata(item, index, 'email')}</td>
                    <td>{itemdata(item, index, 'pincode')}</td>
                    <td>{itemdata(item, index, 'state', true)}</td>
                    <td>{itemdata(item, index, 'city')}</td>

                    <td>{itemdata(item, index, 'GST')}</td>
                    <td>{itemdata(item, index, 'PAN')}</td>
                    <td>{itemdata(item, index, 'aadharNo')}</td>
                    <td>{itemdata(item, index, 'address', true)}</td>
                </tr>
            </>
        );
    });

    const downLoadFile = () => {
        try {
            const data = [
                {
                    fullName: 'Jack',
                    companyName: 'Jack Company',
                    phone: '8989898989',
                    email: 'test@test.com',
                    pincode: '303301',
                    state: 'Rajasthan',
                    city: 'Jaipur',
                    GST: 'SDFRT7878YU78RT',
                    PAN: 'JKUIK8989I',
                    aadharNo: '675645676789',
                    address: 'jaipur address',
                },
            ];

            const ws = XLSX.utils.json_to_sheet(data);

            const data2 = [
                { keyName: 'fullName', Description: `This is tranporter's full name` },
                { keyName: 'companyName', Description: `This is tranporter's company name` },
                { keyName: 'phone', Description: `This is tranporter's phone no` },
                { keyName: 'pincode', Description: `This is tranporter's pincode` },
                { keyName: 'state', Description: `This is tranporter's state name` },
                { keyName: 'city', Description: `This is tranporter's city name` },
                { keyName: 'GST', Description: `This is tranporter's GST no (SDFRT7878YU78RT)` },
                { keyName: 'PAN', Description: `This is tranporter's PAN no (JKUIK8989I)` },
                { keyName: 'aadharNo', Description: `This is tranporter's Aadhar no((675645676789)` },
                { keyName: 'address', Description: `This is tranporter's full address` },
            ];
            const ws2 = XLSX.utils.json_to_sheet(data2);

            // const columns = ["pickupCity", "pickUpDate", "deliveryCity", "deliveryDate", "cutOffTime", "users", "materialType", "weight", "itemUnit", "noOfVehicles", "minBidRate", "maxBidRate", "description"];
            // const ws = XLSX.utils.aoa_to_sheet([columns]);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
            XLSX.utils.book_append_sheet(workbook, ws2, 'Sheet2');
            XLSX.writeFile(workbook, 'Transporter_users.xlsx');
        } catch (error) { }
    };

    function generateRandomID() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let randomID = '';

        for (let i = 0; i < 7; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            randomID += characters.charAt(randomIndex);
        }

        return randomID;
    }

    const uploadFile = async () => {
        const deepList = JSON.parse(JSON.stringify(list));

        setDemandStatus('');
        try {
            handelModel(false);
            setProgressType(true);

            const randomId = generateRandomID();
            localStorage.setItem('randomId', randomId);

            const formData = new FormData();
            formData.append('file', upfile);

            setProgress(true);

            const updateddata = await APIService.post(`bulk/transporter_app_user/${randomId}`, formData, true, true);

            if (updateddata.status === 200) {
                // Notify("success", "File uploaded successfully");

                setUploadTrue(false);
            } else {
                setProgress(false);
                handelModel(true);
                setshowHideUploadBtn(false);
            }
        } catch (error) {
            setProgress(false);
            handelModel(true);
            setshowHideUploadBtn(false);
            setListError(deepList, error?.response?.data?.data, 0);
        }
    };

    const setListError = (lists, data: any, i) => {
        try {
            if (data?.[i]) {
                const indx = data[i]['index'] - 2;

                if (lists[indx]) {
                    lists[indx]['errors'] = data[i]['error'];
                }
                i++;
                setListError(lists, data, i);
            } else {
                setList(lists);
            }
        } catch (error) { }
    };

    return (
        <>
            {props.showHideModel && (
                <Modal
                    scrollable={true}
                    show={true}
                    onHide={() => {
                        handelModel(false);
                        setUploadTrue(false);
                    }}
                    backdrop="static"
                    keyboard={false}
                    size={uploadTrue ? 'lg' : 'md'}
                    dialogClassName={uploadTrue ? 'modal-width' : 'modal-width-med'}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{'Bulk Upload'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Todo Implement loader stucking */}
                        {loaderstate ? (
                            <div className="bulkloader">
                                <p style={{ fontSize: '17px', color: '#03446f' }}>
                                    Loading...{' '}
                                    <span>
                                        <img src="assets/images/dotloading.svg" style={{ width: '26px' }} />
                                    </span>
                                </p>
                                {/* <AiOutlineLoading3Quarters className='animatedloader' style={{ animation: "spin 1s infinite linear" }} /> */}
                            </div>
                        ) : (
                            <div>
                                <input
                                    style={{ display: 'none' }}
                                    type="file"
                                    name="myFile"
                                    className="drop-zone__input"
                                    id="panDoc"
                                    accept=".xlsx, .csv"
                                    onChange={handlefile}
                                />
                                {uploadTrue ? (
                                    <div className="table_box_cover">
                                        <table
                                            className="dataTable display manage_Penalty_table"
                                            style={{ width: '100%' }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="no-sort">SN.</th>
                                                    <th className="no-sort">FullName</th>
                                                    <th className="no-sort">Company Name</th>
                                                    <th className="no-sort">Phone</th>
                                                    <th className="no-sort">Email</th>
                                                    <th className="no-sort">Pincode</th>
                                                    <th className="no-sort">State</th>
                                                    <th className="no-sort">City</th>
                                                    <th className="no-sort">Gst No.</th>
                                                    <th className="no-sort">Pan No.</th>
                                                    <th className="no-sort">Aadhar No.</th>
                                                    <th className="no-sort">Address</th>
                                                </tr>
                                            </thead>
                                            <tbody>{listLog}</tbody>
                                        </table>
                                        {showHideUploadBtn && uploadTrue ? (
                                            ''
                                        ) : (
                                            <div className="uploadlisterror">
                                                <span style={{ color: '#BB0A1E' }}>
                                                    <span className="material-symbols-outlined">error</span> &nbsp;
                                                    There appears to be an error in the uploaded file. Please review the
                                                    content above for any errors.
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <>
                                        <div className="bulkupload">
                                            <img
                                                src="assets/images/excelicon.svg"
                                                className="img-fluid"
                                                style={{ marginTop: '-16px' }}
                                            />
                                            <div className="browsefile" style={{ paddingTop: '17px' }}>
                                                <button
                                                    className="btn custom_btn unfill_btn with_icon folderopen"
                                                    onClick={() => {
                                                        document.getElementById('panDoc')?.click();
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined">folder_open</span>
                                                    <span
                                                        className="d-flex"
                                                        style={{
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            flexDirection: 'row',
                                                        }}
                                                    >
                                                        <span className="browsetext"> Browse File </span> (.xls, .xlsx
                                                        or .csv){' '}
                                                    </span>
                                                </button>

                                                <p className="sub_box file-size-text">( Max file size 1 MB )</p>
                                            </div>
                                            <span style={{ marginTop: '-22px' }}>
                                                <span className="downloaded_file_link" onClick={downLoadFile}>
                                                    Download Sample File{' '}
                                                </span>
                                                <span>
                                                    <img src="assets/images/dowloadloading.svg" />
                                                </span>
                                            </span>
                                        </div>
                                        <br />
                                        <div className="uploadlist">
                                            <span>
                                                <span className="material-symbols-outlined">error</span> &nbsp;Upload
                                                .xls or .csv file to continue. Please note the followings things before
                                                proceeding further:
                                            </span>
                                            {props.type === 'transporter' ? (
                                                <ol>
                                                    <li>
                                                        Pickup pincode should not be more than six digits (Numeric).
                                                    </li>
                                                    <li>Make sure pickup city spelling is correct.</li>
                                                </ol>
                                            ) : (
                                                <ol>
                                                    <li>Verify that the PAN card number is correct.</li>
                                                    <li>Verify that the Aadhaar card number is correct.</li>
                                                    <li>Verify that the GST number is correct.</li>
                                                </ol>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                    {loaderstate ? (
                        ''
                    ) : (
                        <Modal.Footer>
                            {showHideUploadBtn && uploadTrue ? (
                                <Button
                                    variant="secondary"
                                    className="btn dark_btn custom_btn"
                                    onClick={() => {
                                        uploadFile();
                                    }}
                                >
                                    Uploads
                                </Button>
                            ) : (
                                // <Button
                                //     variant="secondary"
                                //     className="btn dark_btn custom_btn"

                                // >
                                //     Add
                                // </Button>

                                ''
                            )}
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    handelModel(false);
                                    setUploadTrue(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    )}
                </Modal>
            )}
        </>
    );
};

export default BulkUploadTransportAppUser;
